export enum AcceptTypesEnum {
  IMAGE = 'image/png, image/jpeg, image/jpg',
  PDF_IMAGE = 'application/pdf, image/png, image/jpeg, image/jpg',
  PDF = 'application/pdf',
  DOCUMENTS = 'application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  IMAGES_ONLY = 'image/png, image/jpeg, image/jpg, image/gif',
  TEXT = 'text/plain',
  ALL_FILES = '*/*',
}
